export const FORESTAGE_WEB = 'PROJECT/FORESTAGE_WEB';
export const FORESTAGE_APP = 'PROJECT/FORESTAGE_APP';
export const BACKSTAGE = 'PROJECT/BACKSTAGE';
